import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[konResourceTableColumn]',
  standalone: true,
})
export class ResourceTableColumnDirective {
  constructor(public readonly template: TemplateRef<any>) {}

  @Input({ required: true, alias: 'konResourceTableColumn' })
  tableColumn!: string;
}
